export default __webpack_public_path__ + "static/media/bg1.fc3658df.svg";